exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-39fe928a] {\n  max-width: 360px;\n}\n.info-icon[data-v-39fe928a] {\n  color: #2b93ff !important;\n}\n.info-button[data-v-39fe928a] {\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n", ""]);

// exports
